import { TextInputNew } from '../../../../../components/AdminInputs'
import { useEffect } from 'react'
import { RootStore } from '../../../../../data/store'

function filterFirstFourDigits(input) {
  // Match only digits in the string and extract the first 4
  const digits = input?.match(/\d/g) ?? '' // Extract all digits from the string
  if (digits) {
    return digits.slice(0, 4).join('') // Return the first 4 digits as a string
  }
  return '' // Return empty string if no digits found
}

export const AadhaarAwareTextInput = ({ docTypeFieldName, onValidationChange, ...props }: any) => {
  const isAadhaar =
    RootStore?.documentCategories?.find((doc) => doc.value === props.allValues?.[docTypeFieldName])?.key === 'Z00005'
  const modifiedPlaceholder = isAadhaar ? 'Last 4 digit of Aadhaar' : props.placeholder
  useEffect(() => {
    let modiFiedValue = props.value
    if (isAadhaar) {
      modiFiedValue = filterFirstFourDigits(props.value)
      props.setFieldValue(props.fieldName, modiFiedValue)
    }
    const isValid = isAadhaar ? modiFiedValue?.length === 4 : !!modiFiedValue
    onValidationChange(isValid)
  }, [isAadhaar])
  const onChange = (text) => {
    let newValue = text
    if (isAadhaar) {
      newValue = filterFirstFourDigits(text)
    }
    const isValid = isAadhaar ? newValue?.length === 4 : !!newValue
    onValidationChange(isValid)
    props.setFieldValue(props.fieldName, newValue)
  }
  const error =
    !!props.value && props.value?.length !== 4 && !!props.error && isAadhaar ? 'Enter 4 digits' : props.error

  return <TextInputNew {...props} touched onChange={onChange} placeholder={modifiedPlaceholder} error={error} />
}
